import * as actionTypes from '../types/userManual';

export function getUserManual(payload) {
  return {
    type: actionTypes.GET_USER_MANUAL,
    payload
  };
}
export function getUserManualSuccess(payload) {
  return {
    type: actionTypes.GET_USER_MANUAL_SUCCESS,
    payload
  };
}
export function getUserManualFail(payload) {
  return {
    type: actionTypes.GET_USER_MANUAL_FAIL,
    payload
  };
}

export function setUserManual(payload) {
  return {
    type: actionTypes.SET_USER_MANUAL,
    payload
  };
}
export function setUserManualSuccess(payload) {
  return {
    type: actionTypes.SET_USER_MANUAL_SUCCESS,
    payload
  };
}
export function setUserManualFail(payload) {
  return {
    type: actionTypes.SET_USER_MANUAL_FAIL,
    payload
  };
}

export function getListChapters(payload) {
  return {
    type: actionTypes.GET_LIST_CHAPTERS,
    payload
  };
}
export function getListChaptersSuccess(payload) {
  return {
    type: actionTypes.GET_LIST_CHAPTERS_SUCCESS,
    payload
  };
}
export function getListChaptersFail(payload) {
  return {
    type: actionTypes.GET_LIST_CHAPTERS_FAIL,
    payload
  };
}

export function addOrEditChapter(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_CHAPTER,
    payload
  };
}
export function addOrEditChapterSuccess(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_CHAPTER_SUCCESS,
    payload
  };
}
export function addOrEditChapterFail(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_CHAPTER_FAIL,
    payload
  };
}

export function addOrEditManual(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_MANUAL,
    payload
  };
}
export function addOrEditManualSuccess(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_MANUAL_SUCCESS,
    payload
  };
}
export function addOrEditManualFail(payload) {
  return {
    type: actionTypes.ADD_OR_EDIT_MANUAL_FAIL,
    payload
  };
}
export function chaptersInit(payload) {
  return {
    type: actionTypes.CHAPTERS_INIT,
    payload
  };
}
export function deleteChapter(payload) {
  return {
    type: actionTypes.DELETE_CHAPTER,
    payload
  };
}
export function deleteChapterSuccess(payload) {
  return {
    type: actionTypes.DELETE_CHAPTER_SUCCESS,
    payload
  };
}
export function deleteChapterFail(payload) {
  return {
    type: actionTypes.DELETE_CHAPTER_FAIL,
    payload
  };
}
export function deleteManual(payload) {
  return {
    type: actionTypes.DELETE_MANUAL,
    payload
  };
}
export function deleteManualSuccess(payload) {
  return {
    type: actionTypes.DELETE_MANUAL_SUCCESS,
    payload
  };
}
export function deleteManualFail(payload) {
  return {
    type: actionTypes.DELETE_MANUAL_FAIL,
    payload
  };
}
export function moveChapter(payload) {
  return {
    type: actionTypes.MOVE_CHAPTER,
    payload
  };
}
export function moveChapterSuccess(payload) {
  return {
    type: actionTypes.MOVE_CHAPTER_SUCCESS,
    payload
  };
}
export function moveChapterFail(payload) {
  return {
    type: actionTypes.MOVE_CHAPTER_FAIL,
    payload
  };
}
export function moveManual(payload) {
  return {
    type: actionTypes.MOVE_MANUAL,
    payload
  };
}
export function moveManualSuccess(payload) {
  return {
    type: actionTypes.MOVE_MANUAL_SUCCESS,
    payload
  };
}
export function moveManualFail(payload) {
  return {
    type: actionTypes.MOVE_MANUAL_FAIL,
    payload
  };
}
export function videoViewerOpen(payload) {
  return {
    type: actionTypes.VIDEO_VIEWER_OPEN,
    payload
  };
}
export function videoViewerClose(payload) {
  return {
    type: actionTypes.VIDEO_VIEWER_CLOSE,
    payload
  };
}
export function videoViewerByStockOpen(payload) {
  return {
    type: actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN,
    payload
  };
}
export function videoViewerByStockOpenSuccess(payload) {
  return {
    type: actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN_SUCCESS,
    payload
  };
}
export function videoViewerByStockOpenFail(payload) {
  return {
    type: actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN_FAIL,
    payload
  };
}
